<template>
  <Question isMSDCustom :customCompanyId="customCompanyId" :surveyInfo="surveyInfo"></Question>
</template>

<script>
import Question from '../question/index.vue'
import { ROOT_COMPANY_ID } from '@/constant/company'

export default {
  components: {
    Question
  },
  props: {
    surveyInfo: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      companyId: ROOT_COMPANY_ID.MSD
    }
  },
  computed: {
    customCompanyId () {
      if (this.$route.meta?.customCompanyId) {
        return this.$route.meta?.customCompanyId
      }
      return this.companyId
    }
  },
  created () {

  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
